import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {
	diamondAmountContainer: {
		display      : "flex",
		alignItems   : "center",
		background   : theme.other.darkMode ? theme.other.paletteNew.darkModeWhite20 : "#d8d8d8",
		padding      : "0.25rem 1rem",
		borderRadius : "0.5rem",
		margin       : "0 0.5rem "
	},
	diamondSvg: {
		height      : "1.75rem",
		width       : "1.75rem",
		marginRight : "0.5em"
	},
	userName: {
		color      : theme.other.colors.text.secondary,
		fontSize   : "1.3rem",
		fontWeight : "500",
		display    : "inline-flex",
		alignItems : "center"
	},
	svgVerifiedIcon: {
		width      : "1.75rem",
		height     : "1.75rem",
		marginLeft : "0.5rem"

	},
	tagContainer: {
		display : "flex",
		padding : "0 0.5rem"
	},
	tag: {
		width  : "auto",
		height : "17px"
	},
	anchorTag: {
		all    : "unset",
		cursor : "pointer"
	}
} ) );
